import { render, staticRenderFns } from "./NavigationMenuPromoProduct.vue?vue&type=template&id=87598cee"
import script from "./NavigationMenuPromoProduct.vue?vue&type=script&lang=js"
export * from "./NavigationMenuPromoProduct.vue?vue&type=script&lang=js"
import style0 from "./NavigationMenuPromoProduct.vue?vue&type=style&index=0&id=87598cee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports